import React, {PureComponent} from 'react'
import {compose} from 'redux'
import {graphql} from 'react-apollo'
import {Route} from 'react-router-dom'
import Helmet from 'react-helmet'

const defaultOptions = {
    props: ({data}) => ({...data})
}

export const Loading = () => (
    <Route render={routeProps => (
        <div className="loading-indicator card">
            <div className="card-body">...</div>
        </div>
    )}/>
)

export const Error = ({message}) => {
  const errorText = message.replace(/^graphql error:/i, '').trim();
  const isAccessDenied = errorText === "Access is denied";
  return (
    <div className="error-container card border-0">
      {isAccessDenied ?
        <div className="card-body">
          <div className="mb-0">
            <h3>{errorText}</h3>
            <p>Please try opening the survey with the link in the invitation email.</p>
          </div>
        </div>
        :
        <div className="card-body p-0">
          <div className="alert alert-danger mb-0">
            {errorText}
          </div>
        </div>
      }
    </div>
  );
}

export const ApplicationLoader = ({error}) => {
  return (
    <main className="application">
      <Helmet>
        <body className="home"/>
      </Helmet>
      <section className="home xxx">
        {error
          ? <Error {...error}/>
          : <Loading/>
        }
      </section>
    </main>
  );
}

export const withData = (query, options = {}, componentLoading = false) => WrappedComponent => {
    const queryOptions = {...defaultOptions, ...options}

    class WithData extends PureComponent {
        render() {
            const {loading, error} = this.props;

            if (loading && !componentLoading) {
                return <Loading/>
            }

            if (loading && componentLoading) {
                return <div className="placeholder" />
            }

            if (error) {
                return <Error {...error}/>
            }

            return <WrappedComponent {...this.props}/>
        }
    }

    return compose(
        graphql(query, queryOptions)
    )(WithData)
}



// WEBPACK FOOTER //
// ./src/decorators/with-data.js